import { useMemo, useState } from 'react';

import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row, Typography } from 'antd';

import SearchTags from 'components/Pages/Public/MarketPlace/SearchTags';
import { IFilter } from 'services/marketplace/types';

import Filters from './Filters';
import styles from './styles.module.css';

const { Title } = Typography;

type ListFilterProps = {
  filters: IFilter;
  setFilters: React.Dispatch<React.SetStateAction<IFilter>>;
  selectedLocale?: string;
  handleRemoveSearch: () => void;
};

const ListFilter = ({ filters, setFilters, selectedLocale, handleRemoveSearch }: ListFilterProps) => {
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const isOnline = filters.type === 'online';

  const hasFilters = useMemo(() => {
    return Object.keys(filters).filter(filter => filters[filter]).length > 1;
  }, [filters]);

  const handleRemoveFilters = () => {
    setFilters({
      page: 1
    });
  };

  const TitleText = () => {
    if (!hasFilters) return;

    const showLocale = Object.keys(filters).filter(filter => ['page', 'region'].indexOf(filter) === -1).length > 0;

    if (selectedLocale && showLocale && !isOnline) {
      return (
        <Col span={24}>
          <Title level={5} className={styles.sectionTitle}>
            {selectedLocale === 'Brasil' ? (
              <>Esse foi o resultado para sua busca:</>
            ) : (
              <>
                Eventos em <span className={styles.localeText}>{selectedLocale}</span>
              </>
            )}
          </Title>
        </Col>
      );
    }

    if (selectedLocale && !isOnline) {
      return (
        <Col span={24}>
          <Title level={5} className={styles.sectionTitle}>
            Eventos em <span className={styles.localeText}>{selectedLocale}</span>
          </Title>
        </Col>
      );
    }

    return (
      <Col span={24}>
        <Title level={5} className={styles.sectionTitle}>
          Esse foi o resultado para sua busca:
        </Title>
      </Col>
    );
  };

  return (
    <Row gutter={[10, 10]} justify='space-between' className={styles.container}>
      <TitleText />
      <Col xs={24} sm={24}>
        {hasFilters ? (
          <SearchTags search={filters.search} removeSearch={handleRemoveSearch} />
        ) : (
          <Title level={4} className={styles.sectionTitle}>
            Veja todos os eventos disponíveis
          </Title>
        )}
      </Col>

      <Col xs={0} md={24} className={styles.filters}>
        <Filters filters={filters} setFilters={setFilters} />
      </Col>

      <Col xs={24} md={0} className={styles.center}>
        <Button className={styles.button}>
          {!hasFilters ? (
            <span className={styles.buttonText} onClick={() => setOpenFilterModal(true)}>
              Selecione um filtro <FilterOutlined />
            </span>
          ) : (
            <span className={styles.buttonText} onClick={handleRemoveFilters}>
              Limpar filtros <CloseOutlined />
            </span>
          )}
        </Button>
      </Col>

      <Modal open={openFilterModal} title='Filtrar por' footer={null} onCancel={() => setOpenFilterModal(false)}>
        <div className={styles.mobileFilters}>
          <Filters filters={filters} setFilters={setFilters} />
        </div>
      </Modal>
    </Row>
  );
};

export default ListFilter;
